import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-587c5fe8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "table-box" }
const _hoisted_2 = { class: "rmb" }
const _hoisted_3 = {
  key: 0,
  class: "button-div"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "buttons" }, "普通发票-个人", -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = {
  key: 1,
  class: "button-div"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "buttons" }, "普通发票-单位", -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = {
  key: 2,
  class: "button-div"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "buttons" }, "专用增值税发票", -1))
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = { class: "button-div" }
const _hoisted_13 = { class: "buttons" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "button" }, "申请开票", -1))
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = ["onClick"]
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "button" }, "已申请", -1))
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = ["onClick"]
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "button" }, "已开票", -1))
const _hoisted_22 = [
  _hoisted_21
]

import { userApi } from "@/service/api"
import { onMounted, reactive, ref, toRefs } from "vue"
import InvoiceDialog from "@/components/common/Dialog/InvoiceDialog.vue"
import InvoiceFrom from "@/components/common/Dialog/item/InvoiceFrom.vue"

interface Props {
  accountList: Array<any>
  loading: boolean
}
interface addressType {
  data: any
}

export default /*#__PURE__*/_defineComponent({
  __name: 'NoApply',
  props: {
    accountList: null,
    loading: { type: Boolean }
  },
  emits: ["editChange"],
  setup(__props: any, { emit }) {

const props = __props as {
  accountList: Array<any>
  loading: boolean
};




const { accountList,loading } = toRefs(props)
let isEdit = ref(true)
let openInvoice = (index: number, mtype: number = 0) => {
  sonRef.value?.setVisible(true)
  recordId.value = accountList.value[index].id
  //todo  通过recrdid获取已经填写的信息
  //  调用一下发票显示接口
  userApi.invoiceShow().then((res: any) => {
    if (res.datas.length != 0) {
      if (mtype == 0) {
        goShow.value = true
      } else if (mtype == 1) {
        goShow.value = false
      } else {
        goShow.value = false
        isEdit.value = false
      }

      lastInfor.data = res.datas
    }
  })
}

//弹出框 start
let addressItem = reactive({
  data: {},
})
let lastInfor: addressType = reactive({
  data: {},
})
let recordId = ref("")
let goShow = ref(true)
const sonRef = ref<InstanceType<typeof InvoiceDialog>>()
let dialogVisible = ref(false)

let mclose = (type: number = 0) => {
  dialogVisible.value = false
  sonRef.value?.setVisible(dialogVisible.value)
  addressItem.data = {}
  emit("editChange")
}
let from = ref(2)
let changeGoShow = (val: boolean) => {
  goShow.value = val
}

onMounted(() => {
  // console.log(props.accountList)
})
//end

//     return {
//       addressItem,
//       lastInfor,
//       recordId,
//       goShow,
//       mclose,
//       from,
//       changeGoShow,
//       openInvoice,
//       sonRef,
//       isEdit,
//     }
//   },
// })

return (_ctx: any,_cache: any) => {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_Title = _resolveComponent("Title")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      data: _unref(accountList),
      class: "table",
      stripe: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          prop: "ctime",
          label: "交易时间",
          width: "210px"
        }),
        _createVNode(_component_el_table_column, {
          prop: "money",
          label: "RMB/元",
          width: "174px"
        }, {
          default: _withCtx((scope) => [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", null, "¥" + _toDisplayString(scope.row.money), 1)
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "detail",
          label: "交易明细",
          width: "174px"
        }),
        _createVNode(_component_el_table_column, {
          prop: "bill_type",
          label: "发票类型",
          width: "174px"
        }, {
          default: _withCtx((scope) => [
            (scope.row.bill_type == '1' && scope.row.bill_iv_type == 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_5))
              : _createCommentVNode("", true),
            (scope.row.bill_type == '2' && scope.row.bill_iv_type == 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_8))
              : _createCommentVNode("", true),
            (scope.row.bill_iv_type == 2)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, _hoisted_11))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "bill_type",
          label: "订单号",
          width: "174px"
        }, {
          default: _withCtx((scope) => [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("span", _hoisted_13, "订单：" + _toDisplayString(scope.row.trade_no), 1)
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "status1",
          label: "开票进度",
          width: "174px"
        }, {
          default: _withCtx((scope) => [
            (scope.row.status1 == '1')
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  onClick: ($event: any) => (_unref(openInvoice)(scope.$index)),
                  class: "button-div"
                }, _hoisted_16, 8, _hoisted_14))
              : _createCommentVNode("", true),
            (scope.row.status1 == '2')
              ? (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  onClick: ($event: any) => (_unref(openInvoice)(scope.$index, 2)),
                  class: "button-div"
                }, _hoisted_19, 8, _hoisted_17))
              : _createCommentVNode("", true),
            (scope.row.status1 == '3')
              ? (_openBlock(), _createElementBlock("div", {
                  key: 2,
                  onClick: ($event: any) => (_unref(openInvoice)(scope.$index, 2)),
                  class: "button-div"
                }, _hoisted_22, 8, _hoisted_20))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data"])), [
      [_directive_loading, _unref(loading)]
    ]),
    _createVNode(InvoiceDialog, {
      ref_key: "sonRef",
      ref: sonRef,
      dialogwidth: "625px",
      addressItems: _unref(addressItem),
      lastInfor: _unref(lastInfor)
    }, {
      header: _withCtx(() => [
        _createVNode(_component_Title, {
          headerHeight: 40,
          headerBC: "#F2F5FA"
        }, {
          default: _withCtx(() => [
            _createElementVNode("template", null, [
              _createElementVNode("i", {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(mclose)())),
                class: "icon iconfont icon-shanchu"
              })
            ])
          ]),
          _: 1
        })
      ]),
      default: _withCtx(({ addressItems }) => [
        (_unref(isEdit))
          ? (_openBlock(), _createBlock(InvoiceFrom, {
              key: 0,
              onMclose: _unref(mclose),
              lastInfor: _unref(lastInfor),
              recordId: _unref(recordId),
              goShow: _unref(goShow),
              from: _unref(from),
              onChangeGoShow: _unref(changeGoShow)
            }, null, 8, ["onMclose", "lastInfor", "recordId", "goShow", "from", "onChangeGoShow"]))
          : (_openBlock(), _createBlock(InvoiceFrom, {
              key: 1,
              onMclose: _unref(mclose),
              lastInfor: _unref(lastInfor),
              recordId: _unref(recordId),
              goShow: _unref(goShow),
              isEdit: false,
              from: _unref(from),
              onChangeGoShow: _unref(changeGoShow)
            }, null, 8, ["onMclose", "lastInfor", "recordId", "goShow", "from", "onChangeGoShow"]))
      ]),
      _: 1
    }, 8, ["addressItems", "lastInfor"])
  ]))
}
}

})